import {clone} from 'ramda'
import Debug from 'debug'
const debug = Debug('app:settings:profile')
import forgotCtrl from '../../login/forgot/forgot.ctrl'
import forgotTpl from '../../login/forgot/forgot.html'

class profileController {
  /* @ngInject */
  constructor (Users, Auth, $state, $rootScope, $mdToast, $scope, user, $mdDialog) {
    console.log('user', user.profilePic)
    this.$rootScope = $rootScope
    this.Users = Users
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.$scope = $scope
    this.updateProfile
    var phone = user.phone
    this.user = user
    this.user.phone = phone.slice(1)
    $scope.profilePic = user.profilePic

    this.Auth = Auth
    this.$state = $state

    $scope.imageUpload = (elem) => {
      const reader = new FileReader()
      reader.onload = $scope.imageIsLoaded
      reader.readAsDataURL(elem.files[0])
    }

    $scope.imageIsLoaded = (e) => {
      $scope.profilePic = e.target.result
      this.photoChosen = true
      this.editPhoto = false
      $scope.$apply()
    }

    this.editPhoto = false
    this.photoChosen = false
    this.myCroppedImage = '' // in this variable you will have dataUrl of cropped area.
  }

  toast (content) {
    this.$scope.$parent.app.showSimpleToast(content)
  }

  saveProfile () {
    if (this.updateProfile.$invalid) {
      debug('form not valid!')
      debug(this.updateProfile)
      return
    }

    const updateData = clone(this.user)
    updateData.phone = '1' + this.user.phone

    debug('updateUser %o', this.updateProfile)
    this.Users.updateUser({
      userInfo: updateData
    })
      .then(() => {
        const msg = 'Profile Info Updated!!'
        this.toast(msg)
      })
      .catch((err) => {
        if (!err) return
        debug(err)
        this.toast('Failed To Update Profile Info')
      })
  }

  uploadPicture () {
    var data = this.myCroppedImage.substring(this.myCroppedImage.indexOf(',') + 1)
    return this.Users.uploadProfilePic({
      profilePicture_base64: data
    })
    .then((res) => {
      const profilePicKey = 'profilePic'
      this.Users.updateMe(profilePicKey, res.data.url)
      this.photoChosen = false
      const msg = 'Profile Picture Uploaded!'
      this.toast(msg)
    })
    .catch((err) => {
      if (!err) return
      this.toast('Unable to Upload Profile Picture')
    })
  }

  reset ($ev) {
    const confirm = {
      controller: forgotCtrl,
      controllerAs: 'f',
      template: forgotTpl,
      targetEvent: $ev,
      clickOutsideToClose: true
    }

    return this.$mdDialog.show(confirm)
  }
}

export default profileController
